import request from './request'

export function listAfterSales(params) {
  return request.get('/biz/after-sales', { params })
}
export function getAfterSale(id) {
  return request.get(`/biz/after-sales/${id}`)
}
export function handleAfterSale(id, data) {
  return request.post(`/biz/after-sales/${id}/handle`, data)
}

export function listSuggests(params) {
  return request.get('/biz/suggests', { params })
}
export function getSuggest(id) {
  return request.get(`/biz/suggests/${id}`)
}
export function handleSuggest(id, data) {
  return request.post(`/biz/suggests/${id}/handle`, data)
}
